import classNames from "classnames";
import isString from "lodash/isString";
import { ActivityState, UIWorkflowState } from "PFTypes";
import { useTranslation } from "react-i18next";
import { humanize, titleize } from "underscore.string";

import { Pill } from "../pill/pill";
import css from "./role_status_badge.module.scss";

type RoleStatusBadgeProps = {
  workflowState?: UIWorkflowState;
  state?: ActivityState;
  className?: string;
  getTitle?: (stateText?: string) => string;
  children?: React.ReactNode;
};

export const RoleStatusBadge = ({
  workflowState,
  state,
  className,
  getTitle,
  children
}: RoleStatusBadgeProps) => {
  const { t } = useTranslation("core");

  const translationKey = workflowState
    ? `roleStatus.workflowState.${workflowState}`
    : `roleStatus.state.${state}`;

  const text =
    children ||
    t(translationKey as unknown as TemplateStringsArray, titleize(humanize(workflowState || state || "")));

  if (!text) {
    return null;
  }

  return (
    <Pill
      classes={{ root: classNames(className, workflowState && css[`dataType-${workflowState}`]) }}
      title={getTitle?.(isString(text) ? text : undefined)}
      small
    >
      {text}
    </Pill>
  );
};
